import { FormUserMessages, TranslationFormUserMessages } from "../interfaces";

export const messages: TranslationFormUserMessages = {
  [FormUserMessages.fieldEmail]: "Email",
  [FormUserMessages.fieldName]: "Name",
  [FormUserMessages.fieldPosition]: "Position",
  [FormUserMessages.fieldDescription]: "Description",
  [FormUserMessages.fieldActive]: "This user is active",
  [FormUserMessages.fieldInactive]: "This user is inactive",
  [FormUserMessages.addImage]: "Add picture",
  [FormUserMessages.removeImage]: "Remove picture",
  [FormUserMessages.deletionConfirmationTitleModal]: "Deletion confirmation",
  [FormUserMessages.deletionConfirmationSubtitleModal]: "By confirming, the user will be removed from all Topcon solutions. "
      + "Are you sure you want to continue?"
};